<template>
  <div>
    <el-form :model="form" :disabled="onlyInfo" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
      <el-row :gutter="20">
        <el-col :span="8" :offset="0">
          <el-form-item prop="code">
            <el-input label="Item Code" v-model.trim="form.code" maxlength="10" show-word-limit></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6" :offset="0">
          <el-form-item prop="vendorId">
            <el-select v-model="form.vendorId" placeholder="Vendor" clearable filterable style="width: 100%;">
              <el-option v-for="item in vendors"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="8" :offset="0">
          <el-form-item prop="name">
            <el-input label="Item Name" v-model="form.name" maxlength="100" show-word-limit></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="0">
          <el-form-item prop="unitId">
            <el-select v-model="form.unitId" placeholder="Units of Measure" clearable filterable style="width: 100%;">
              <el-option v-for="item in units"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <h4 style="margin-bottom: 5px;">Purchasing Details</h4>
      <h5 style="margin-top: 0; text-decoration: underline;">Asset</h5>

      <el-row :gutter="20">
        <el-col :span="8" :offset="0">
          <el-form-item prop="inventoryAssetAccountId">
            <el-select v-model="form.inventoryAssetAccountId" placeholder="Inventory Asset Account" clearable filterable style="width: 100%;">
              <el-option v-for="item in inventoryAccounts"
                :disabled="item.disable"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8" :offset="0">
          <el-form-item prop="reorderQtyMin">
            <el-input label="Reorder Min Qty" type="text" v-model="form.reorderQtyMin" @input="handleInput($event, 'reorderQtyMin')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="0">
          <el-form-item prop="reorderQtyMax">
            <el-input label="Reorder Max Qty" type="text" v-model="form.reorderQtyMax" @input="handleInput($event, 'reorderQtyMax')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <h4 style="margin-bottom: 5px;">Selling Details</h4>
      <h5 style="margin-top: 0; text-decoration: underline;">Expenditure</h5>

      <el-row :gutter="20">
        <el-col :span="5" :offset="0">
          <el-form-item prop="purchasePrice">
            <!-- <el-input label="Cost Price" type="number" v-model.trim="form.purchasePrice"></el-input> -->
            <money v-model="form.purchasePrice" :disabled="onlyInfo" v-bind="money" prefix="Std Cost: "></money>
          </el-form-item>
        </el-col>
        <el-col :span="11" :offset="0">
          <el-form-item prop="purchaseAccountId">
            <el-select v-model="form.purchaseAccountId" placeholder="COGS Account" clearable filterable style="width: 100%;">
              <el-option v-for="item in purchaseAccounts"
                :disabled="item.disable"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="0">
          <el-form-item prop="purchaseTaxAccountId">
            <el-select v-model="form.purchaseTaxAccountId" placeholder="Tax Rate" clearable filterable style="width: 100%;">
              <el-option v-for="item in purchaseTaxAccounts"
                :disabled="item.disable"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <h4 style="margin: 0; font-weight: normal">Purchase Description</h4>

      <el-form-item prop="purchaseDescription">
        <el-input label="Description" type="textarea" v-model="form.purchaseDescription" maxlength="200" show-word-limit></el-input>
      </el-form-item>

      <h5 style="margin-top: 0; text-decoration: underline;">Revenue</h5>

      <el-row :gutter="20">
        <el-col :span="5" :offset="0">
          <el-form-item prop="sellPrice">
            <!-- <el-input label="Sell Price" type="number" v-model.trim="form.sellPrice"></el-input> -->
            <money v-model="form.sellPrice" :disabled="onlyInfo" v-bind="money" prefix="Sell Price: "></money>
          </el-form-item>
        </el-col>
        <el-col :span="11" :offset="0">
          <el-form-item prop="sellAccountId">
            <el-select v-model="form.sellAccountId" placeholder="Revenue Account" clearable filterable style="width: 100%;">
              <el-option v-for="item in sellAccounts"
                :disabled="item.disable"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="0">
          <el-form-item prop="sellTaxAccountId">
            <el-select v-model="form.sellTaxAccountId" placeholder="Tax Rate" clearable filterable style="width: 100%;">
              <el-option v-for="item in sellTaxAccounts"
                :disabled="item.disable"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <h4 style="margin: 0; font-weight: normal">Selling Description</h4>

      <el-form-item prop="sellDescription">
        <el-input label="Description" type="textarea" v-model="form.sellDescription" maxlength="200" show-word-limit></el-input>
      </el-form-item>

      <el-form-item v-if="!onlyInfo">
        <div class="btn__flex-end">
          <div v-if="isCreate">
            <el-button @click="modalCancel('modal')">{{$t('general_cancel')}}</el-button>
            <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
          </div>
          <div v-else>
            <el-button @click="modalCancel('modal')">{{$t('general_cancel')}}</el-button>
            <el-button @click="editItem('form')" type="primary">{{$t('general_submit')}}</el-button>
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import {Money} from 'v-money'

  export default {
    name: 'inventory',
    components: {
      SweetModal,
      Money,
    },
    props: ['typeId'],
    data() {
      return {
        money: {
          precision: 2,
          decimal: '.',
          thousands: ',',
          masked: false
        },

        isCreate: true,
        row: null,
        onlyInfo: false,

        purchaseAccounts: [],
        purchaseTaxAccounts: [],
        sellAccounts: [],
        sellTaxAccounts: [],
        inventoryAccounts: [],
        units: [],
        vendors: [],

        form: {
          code: '',
          name: '',
          unitId: null,
          // vendorId: null,
          // Purchasing Details
          inventoryAssetAccountId: null,
          // Selling Details
          purchasePrice: null,
          purchaseAccountId: null,
          purchaseTaxAccountId: null,
          purchaseDescription: '',
          sellPrice: null,
          sellAccountId: null,
          sellTaxAccountId: null,
          sellDescription: '',

          reorderQtyMin: null,
          reorderQtyMax: null,
        },

        rules: {
          code: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          unitId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          // Purchasing Details
          inventoryAssetAccountId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          // Selling Details
          purchasePrice: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          purchaseAccountId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          purchaseTaxAccountId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          purchaseDescription: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          sellPrice: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          sellAccountId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          sellTaxAccountId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          sellDescription: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          reorderQtyMin: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          reorderQtyMax: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      async openModal({ isCreate = true, row = {}, onlyInfo = false }) {
        this.onlyInfo = onlyInfo
        this.isCreate = isCreate
        this.row = row
        await this.getDirectories()
        if (!isCreate) {
          await this.handleEdit()
        }
      },
      modalCancel(ref) {
        this.$emit('modalCancel', ref)
      },
      async getDirectories() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/items/directories?companyId=${this.$route.query.companyId}&typeId=${this.typeId}`)
          console.log("🚀 ~ file: CreateUpdateModal.vue:108 ~ directories ~ data:", data)
          this.purchaseAccounts = data.directories.purchaseAccounts
          this.purchaseTaxAccounts = data.directories.purchaseTaxAccounts
          this.sellAccounts = data.directories.sellAccounts
          this.sellTaxAccounts = data.directories.sellTaxAccounts
          this.inventoryAccounts = data.directories.inventoryAccounts
          this.units = data.directories.units
          this.vendors = data.directories.vendors
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      async checkPrice() {
        return (this.form.sellPrice < this.form.purchasePrice) ? true : false
      },
      addItem(form) {
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            if (await this.checkPrice()) {
              this.$confirm('Sell price less than Purchase, confirm if it’s correct. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'info'
              }).then(() => {
                this.addItemRequest()
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: 'Create canceled'
                });
              });
            } else {
              this.addItemRequest()
            }
          } else {
            console.log('Error valid!');
            return false;
          }
        });
      },
      async addItemRequest() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          await axios.post(`/api/v1/items?companyId=${this.$route.query.companyId}`, {
            ...this.form, itemsTypeId: this.typeId, group: [], purchase: true, sell: true
          })
          this.modalCancel('modal')
          this.$emit('loadList')
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      async handleEdit() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/items?id=${this.row.id}`)
          for (const key in this.form) {
            this.form[key] = data.item[key]
          }
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      editItem(form) {
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            if (await this.checkPrice()) {
              this.$confirm('Sell price less than Purchase, confirm if it’s correct. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'info'
              }).then(() => {
                this.editItemRequest()
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: 'Create canceled'
                });
              });
            } else {
              this.editItemRequest()
            }
          } else {
            console.log('Error valid!');
            return false;
          }
        });
      },
      async editItemRequest() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          await axios.put(`/api/v1/items?id=${this.row.id}`, {
            ...this.form, itemsTypeId: this.typeId, group: [], purchase: true, sell: true
          })
          this.modalCancel('modal')
          this.$emit('loadList')
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      handleInput(value, field) {
        const sanitizedValue = value.replace(/[^0-9]/g, '')
        const numericValue = parseFloat(sanitizedValue)
        this.form[field] = isNaN(numericValue) ? null : numericValue
      },
    },
  }
</script>

<style lang="scss" scoped>
/deep/.v-money {
  height: 40px;
  line-height: 40px;
  -webkit-appearance: none;
  background-color: transparent;
  background-image: none;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  padding: 0 15px 0 0;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
}
</style>